import React from "react"
import cn from "classnames"
import { Box } from "@infotech/uikit-grid"
import Select, { components } from "@infotech/uikit-select"
import InfinitySelect from "src/components/Selects/InfinitySelect"
import get from "lodash/get"
import {
  makeTransparent,
  DEFAULT_COLOR,
} from "../../../containers/Calendar/helpers/eventToItem"
import styles from "./styles.css"

const DropdownOption = ({ color, label, className }) => (
  <div className={cn(className, styles[`select-dropdown-option-wrapper`])}>
    {color && (
      <div className={styles[`circle-wrapper`]}>
        <div
          className={styles.circle}
          style={{
            backgroundColor: `${
              color === `#fff` ? DEFAULT_COLOR : makeTransparent(color, 0.4)
            }`,
          }}
        />
      </div>
    )}
    <div className={styles[`select-dropdown-option-label`]}>{label}</div>
  </div>
)

const SingleValue = ({ children, getValue, ...props }) => {
  const value = getValue()[0]
  return (
    <components.SingleValue {...props}>
      {children}
      <DropdownOption className={styles[`select-current-value`]} {...value} />
    </components.SingleValue>
  )
}

const Option = ({ data, data: { color }, ...props }) => (
  <Box loose className={!color && styles.AnyOptionSpace}>
    <components.Option data={data} {...props}>
      <DropdownOption {...data} />
    </components.Option>
  </Box>
)

const CustomPlaceholder = props => (
  <components.Placeholder
    {...props}
    getStyles={componentName => ({
      ...props.getStyles(componentName, props),
      color: props.selectProps.haveAny
        ? props.getStyles(`option`, props).color
        : `#808080`,
    })}
  />
)

export default ({
  placeholder,
  isLoading,
  options,
  haveAny,
  input: { onChange, value },
  meta,
  infinityConfig,
  isDisabled,
}) => {
  const error = get(meta, `error`)
  return (
    <Box loose mb={!error && `2md`} className={styles[`select-max-width`]}>
      {infinityConfig ? (
        <InfinitySelect
          hideSelectedOptions
          infinityConfig={infinityConfig}
          isLoading={isLoading}
          components={{ SingleValue, Option, Placeholder: CustomPlaceholder }}
          isClearable
          isDisabled={isDisabled}
          placeholder={placeholder || `Выберите тип события`}
          haveAny={haveAny}
          options={options}
          value={value}
          onChange={({ target: { value: option } }) => onChange(option)}
          error={error}
        />
      ) : (
        <Select
          hideSelectedOptions
          components={{ SingleValue, Option, Placeholder: CustomPlaceholder }}
          isClearable
          placeholder={placeholder || `Выберите тип события`}
          haveAny={haveAny}
          options={options}
          value={value}
          onChange={({ target: { value: option } }) =>
            onChange(option ? option.value : option)
          }
          error={error}
        />
      )}
    </Box>
  )
}
